import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FundSwitchingRoutingModule } from './fund-switching-routing.module';
import { FundSwitchingComponent } from './components/fund-switching.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
  imports: [
    CommonModule,
    FundSwitchingRoutingModule,
    ReactiveFormsModule,
    TooltipModule.forRoot(),
    TranslateModule.forChild()
  ],
  exports: [
    ReactiveFormsModule
  ],
  declarations: [FundSwitchingComponent]
})
export class FundSwitchingModule {
}
